import { TColors } from '@cian/ui-kit/colors';
import {
  IconMetroEkb16,
  IconMetroKzn16,
  IconMetroMsk16,
  IconMetroNN16,
  IconMetroNovosib16,
  IconMetroSam16,
  IconMetroSpb16,
} from '@cian/ui-kit/icons';
import * as React from 'react';

import * as styles from './styles.css';
import { ECityType } from '../../../../types/newbuildingPromoBuilderOffers';

interface IUndergroundIconProps {
  lineColor: string;
  undergroundCityType: ECityType;
}

const componentMap = {
  [ECityType.Msk]: IconMetroMsk16,
  [ECityType.Spb]: IconMetroSpb16,
  [ECityType.Samara]: IconMetroSam16,
  [ECityType.Ekb]: IconMetroEkb16,
  [ECityType.Kazan]: IconMetroKzn16,
  [ECityType.Nizhniy]: IconMetroNN16,
  [ECityType.Novosib]: IconMetroNovosib16,
};

export const UndergroundIcon = (props: IUndergroundIconProps) => {
  const { undergroundCityType, lineColor } = props;

  const Icon = componentMap[undergroundCityType];

  if (Icon) {
    return (
      <div className={styles['underground-icon']} data-testid="underground_icon" style={{ color: `#${lineColor}` }}>
        <Icon data-testid={`underground_icon_${undergroundCityType}`} color={'currentColor' as TColors} />
      </div>
    );
  }

  return (
    <div
      className={styles['underground-icon--regions']}
      data-testid="underground_with_custom_icon"
      style={{ color: `#${lineColor}` }}
    />
  );
};
